export const environment = {
  production: true,
  apiUrl: 'https://api.mspadek.pl/v1',
  baseUrl: 'https://mspadek.pl',
};
